/*****/ document.addEventListener("DOMContentLoaded", function () {
    function formatPrices() {
        document.querySelectorAll("#_rsi-cod-form-modal .money").forEach(function (el) {
            let priceText = el.innerText.replace(/[^\d]/g, ""); 
            if (priceText) {
                let formattedPrice = Number(priceText).toLocaleString("en-US").replace(/,/g, ".");
                el.innerText = formattedPrice.replace(/\./g, ",");
            }
        });
    }

    // Check if modal is open every second and format prices
    setInterval(function () {
        let modal = document.querySelector("#_rsi-cod-form-modal");
        if (modal && modal.style.display !== "none") {
            formatPrices();
        }
    }, 1000); // Runs every second
});


/****Payment Details Section In REalist COD Block***
document.addEventListener("DOMContentLoaded", function () {

    function insertPaymentSection() {
        let modal = document.querySelector("#_rsi-cod-form-modal");

        if (!modal || modal.style.display === "none") return;

        // Prevent duplicate insert
        if (modal.querySelector(".custom-payment-section")) return;

        let submitBlock = modal.querySelector("._rsi-build-block._rsi-build-block-submit-button");
        if (!submitBlock) return;

        let paymentBox = document.createElement("div");
        paymentBox.className = "custom-payment-section";
        paymentBox.innerHTML = `
            <div style="background:#f8f5e9;padding:18px;border-radius:12px;border:1px solid #e5d8a8;margin-top:15px;">
                <h4 style="margin:0 0 12px 0;font-weight:600; display: none;">💳 Payment Methods Available</h4>

                <div style="margin-bottom:12px;font-size:14px;line-height:1.6;">
                    <strong>Bank Transfer (NCBA Bank)</strong><br>
                    Account Name: Simokai Enterprises<br>
                    Account Number: <strong style="font-size:16px;">7936710016</strong><br>
                    Branch: Wabera Street
                </div>

                <div style="font-size:14px;line-height:1.6;">
                    <strong>M-Pesa Buy Goods</strong><br>
                    Till Number: <strong style="font-size:16px;">848632</strong><br>
                    Business Name: Simokai Enterprises
                </div>
            </div>
        `;

        submitBlock.insertAdjacentElement("beforebegin", paymentBox);
    }

    // Run every second like your formatter
    setInterval(insertPaymentSection, 1000);

});
****/


/**** Cutom Delivery Notice Disclaimer** */
document.addEventListener("DOMContentLoaded", function () {

    function insertDisclaimer() {
        let modal = document.querySelector("#_rsi-cod-form-modal");

        if (!modal || modal.style.display === "none") return;

        let shippingLine = modal.querySelector(
            "._rsi-modal-checkout-line[data-checkout-line='shipping']"
        );

        if (!shippingLine) return;

        let titleEl = shippingLine.querySelector("._rsi-modal-checkout-line-title");

        if (!titleEl) return;

        // prevent duplicates
        if (titleEl.querySelector(".custom-town-disclaimer")) return;

        let disclaimer = document.createElement("span");
        disclaimer.className = "custom-town-disclaimer";
        disclaimer.textContent = " (Varies per town)";

        disclaimer.style.cssText = `
            font-size: 14px;
            color: #777;
            font-weight: 500;
        `;

        titleEl.appendChild(disclaimer);
    }

    setInterval(insertDisclaimer, 1000);

});



document.addEventListener('DOMContentLoaded', () => {
    const menu = document.getElementById('Details-menu-drawer-container');
    const button = document.querySelector('#_rsi-buy-now-button-floating');
    
    if (menu && button) {
        // Store the original display value (defaults to computed style if not set)
        const originalDisplay = window.getComputedStyle(button).display;
        
        new MutationObserver((mutations) => {
            if (menu.classList.contains('menu-opening')) {
                // Hide the button if menu is opening
                button.style.display = 'none';
            } else {
                // Restore the original display value when menu closes
                button.style.display = originalDisplay;
            }
        }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }
});

